import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "maxRows", "minRows", "onChange", "status", "value", "rightSide", "placeholder"];
import React, { forwardRef } from 'react';
import { combineRefs } from '@carnica/utils';
import { cnBem } from "../../lib";
import styles from "./styles.pcss";
import { useTextArea } from "./hooks/useTextArea";
var cnTextArea = cnBem('text-area', styles);
var TextAreaRender = function TextAreaRender(props, ref) {
  var className = props.className,
    maxRows = props.maxRows,
    _props$minRows = props.minRows,
    minRows = _props$minRows === void 0 ? 1 : _props$minRows,
    onChangeProp = props.onChange,
    status = props.status,
    value = props.value,
    rightSide = props.rightSide,
    placeholder = props.placeholder,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useTextArea = useTextArea({
      minRows: minRows,
      maxRows: maxRows,
      onChange: onChangeProp,
      value: value,
      autoFocus: otherProps === null || otherProps === void 0 ? void 0 : otherProps.autoFocus
    }),
    onChange = _useTextArea.onChange,
    textAreaRef = _useTextArea.textAreaRef;
  return /*#__PURE__*/React.createElement("div", {
    className: cnTextArea({
      withSide: !!rightSide
    }, [className]),
    "data-t-id": "ui-TextArea"
  }, /*#__PURE__*/React.createElement("textarea", _extends({
    className: cnTextArea('field', {
      status: status,
      withSide: !!rightSide
    }),
    onChange: onChange,
    placeholder: placeholder,
    ref: combineRefs([ref, textAreaRef]),
    value: value
  }, otherProps)), !!rightSide && /*#__PURE__*/React.createElement("div", {
    className: cnTextArea('side')
  }, rightSide));
};
export var TextArea = /*#__PURE__*/forwardRef(TextAreaRender);